/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormik } from 'formik'
import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useSearchParams } from 'react-router-dom'
import * as Yup from 'yup'
import PhoneInput from '../../../../_metronic/layout/components/Forms/MaskedInput/components/PhoneInput'
import { cadastrarTrial } from '../../../services/Renovacao'

const schema = Yup.object().shape({
  s_nome_loja: Yup.string().trim().max(200, 'Máximo de 200 caracteres').required('Informe o nome da marmoraria'),
  s_email: Yup.string().trim().email('E-mail inválido').max(100, 'Máximo de 100 caracteres').required('Informe o e-mail'),
  s_telefone: Yup.string().trim().required('Informe o telefone'),
})

// Cadastro simples com 30 dias grátis: sem cartão e sem pagamento.
// O backend cria empresa, usuário e licença trial e envia usuário/senha por e-mail.
export function SignUp() {
  const [searchParams] = useSearchParams()
  const [emailCadastrado, setEmailCadastrado] = useState<string>()

  const formik = useFormik({
    initialValues: {
      s_nome_loja: searchParams.get('s_nome') ?? '',
      s_email: searchParams.get('s_email') ?? '',
      s_telefone: searchParams.get('s_telefone') ?? '',
    },
    validationSchema: schema,
    onSubmit: async (values, { setStatus }) => {
      setStatus(undefined)
      try {
        await cadastrarTrial(values.s_nome_loja.trim(), values.s_email.trim(), values.s_telefone.trim())
        setEmailCadastrado(values.s_email.trim())
      } catch (error: any) {
        setStatus(typeof error === 'string' ? error : error?.message ?? 'Não foi possível concluir o cadastro.')
      }
    },
  })

  if (emailCadastrado) {
    return (
      <section className='text-center'>
        <h1 className='mb-5'>Cadastro concluído!</h1>
        <p className='fs-5'>
          Seu teste grátis de 30 dias já está ativo.
          <br />
          Enviamos o usuário e a senha para <strong>{emailCadastrado}</strong>.
        </p>
        <a href='/auth' className='btn btn-primary mt-5'>
          Fazer login
        </a>
      </section>
    )
  }

  return (
    <form className='form' onSubmit={formik.handleSubmit} noValidate id='kt_signup_form'>
      <div className='text-center mb-10'>
        <h1 className='text-dark fw-bolder mb-3'>Teste grátis por 30 dias</h1>
        <div className='text-gray-500 fw-semibold fs-6'>Sem cartão e sem compromisso</div>
      </div>

      {formik.status && (
        <div className='mb-lg-2 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      <Form.Group className='mb-3'>
        <Form.Label className='required'>Nome da marmoraria</Form.Label>
        <Form.Control className='form-control-solid' {...formik.getFieldProps('s_nome_loja')} isInvalid={formik.touched.s_nome_loja && !!formik.errors.s_nome_loja} />
        <Form.Control.Feedback type='invalid'>{formik.errors.s_nome_loja}</Form.Control.Feedback>
      </Form.Group>

      <Form.Group className='mb-3'>
        <Form.Label className='required'>E-mail</Form.Label>
        <Form.Control type='email' className='form-control-solid' {...formik.getFieldProps('s_email')} isInvalid={formik.touched.s_email && !!formik.errors.s_email} />
        <Form.Control.Feedback type='invalid'>{formik.errors.s_email}</Form.Control.Feedback>
      </Form.Group>

      <PhoneInput
        required
        withMarginBottom
        name='s_telefone'
        label='Telefone'
        value={formik.values.s_telefone}
        onChange={formik.handleChange}
      >
        {formik.touched.s_telefone && formik.errors.s_telefone && (
          <div className='text-danger fs-7 mt-1'>{formik.errors.s_telefone}</div>
        )}
      </PhoneInput>

      <div className='d-grid mb-10 mt-6'>
        <button type='submit' id='kt_sign_in_submit' className='btn btn-primary' disabled={formik.isSubmitting}>
          {!formik.isSubmitting && <span className='indicator-label'>Iniciar teste grátis</span>}
          {formik.isSubmitting && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Aguarde...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='mb-4 text-gray-500 text-center fw-semibold fs-6'>
        Já possui cadastro?{' '}
        <a href='/auth' className='link-primary'>
          Fazer login
        </a>
      </div>
      <div className='text-gray-500 text-center fw-semibold fs-7'>
        Precisa de ajuda?{' '}
        <a target='__blank' href='https://magmaprosistemas.com.br/' className='link-primary'>
          Acessar central de ajuda
        </a>
      </div>
    </form>
  )
}
